import { Controller } from "@hotwired/stimulus";
import Swiper from "swiper";
import { Navigation, Pagination, FreeMode, Autoplay } from "swiper/modules";

const ARROW_SVG = `<svg class="swiper-navigation-icon" width="11" height="20" viewBox="0 0 11 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.38296 20.0762C0.111788 19.805 0.111788 19.3654 0.38296 19.0942L9.19758 10.2796L0.38296 1.46497C0.111788 1.19379 0.111788 0.754138 0.38296 0.482966C0.654131 0.211794 1.09379 0.211794 1.36496 0.482966L10.4341 9.55214C10.8359 9.9539 10.8359 10.6053 10.4341 11.007L1.36496 20.0762C1.09379 20.3474 0.654131 20.3474 0.38296 20.0762Z" fill="currentColor"/></svg>`;

export default class extends Controller {
  static values = {
    options: Object,
  };

  connect() {
    this.notEnoughSlides();

    const options = {
      ...this.defaultOptions,
      ...this.optionsValue,
    };

    if (options.navigation) {
      const parent = this.element.parentElement;
      this.nextButton =
        parent?.querySelector(options.navigation.nextEl) || null;
      this.prevButton =
        parent?.querySelector(options.navigation.prevEl) || null;
      delete options.navigation;
    }

    this.swiper = new Swiper(this.element, options);

    if (this.nextButton || this.prevButton) {
      if (this.nextButton && !this.nextButton.querySelector("svg"))
        this.nextButton.innerHTML = ARROW_SVG;
      if (this.prevButton && !this.prevButton.querySelector("svg"))
        this.prevButton.innerHTML = ARROW_SVG;

      this.goNext = () => this.swiper.slideNext();
      this.goPrev = () => this.swiper.slidePrev();
      this.updateNavigation = this.updateNavigation.bind(this);
      this.nextButton?.addEventListener("click", this.goNext);
      this.prevButton?.addEventListener("click", this.goPrev);
      this.swiper.on(
        "setTranslate transitionEnd slideChange snapGridLengthChange resize",
        this.updateNavigation,
      );
      this.updateNavigation();
    }
  }

  disconnect() {
    this.nextButton?.removeEventListener("click", this.goNext);
    this.prevButton?.removeEventListener("click", this.goPrev);
    this.swiper.destroy();
    this.swiper = undefined;
  }

  updateNavigation() {
    const disabledClass = "swiper-button-disabled";
    const lastIndex = this.swiper.snapGrid.length - 1;
    const atStart = this.swiper.snapIndex <= 0;
    const atEnd = this.swiper.snapIndex >= lastIndex;

    if (this.prevButton) {
      this.prevButton.classList.toggle(disabledClass, atStart);
      this.prevButton.setAttribute("aria-disabled", String(atStart));
    }
    if (this.nextButton) {
      this.nextButton.classList.toggle(disabledClass, atEnd);
      this.nextButton.setAttribute("aria-disabled", String(atEnd));
    }
  }

  get defaultOptions() {
    return {
      modules: [Navigation, Pagination, FreeMode, Autoplay],
      freeMode: {
        enabled: true,
        minimumVelocity: 0.2,
        momentum: false,
      },
      slidesPerView: 4.2,
      spaceBetween: 10,
      grabCursor: true,
    };
  }

  notEnoughSlides() {
    const slides = this.element.querySelectorAll(".swiper-slide");

    const maxSlides = 1;

    if (slides.length < maxSlides) {
      this.element.classList.add("not-enough-slides");
    } else {
      this.element.classList.remove("not-enough-slides");
    }
  }
}
